import { api } from '../api';

export type SystemSettingType = 'INTEGER' | 'FLOAT' | 'BOOLEAN' | 'STRING';
export type AuditAction = 'CREATE' | 'UPDATE' | 'DELETE';
export type StaffRole = 'ADMIN' | 'MANAGER' | 'STAFF';

export interface SystemSetting {
  key: string;
  value: string;
  valueType: SystemSettingType;
  updatedBy: string | null;
  updatedAt: string;
}

export interface SystemSettingHistoryEntry {
  id: string;
  action: AuditAction;
  beforeValue: string | null;
  afterValue: string | null;
  createdAt: string;
  staff: { id: string; nickname: string; role: StaffRole };
}

export async function listSettings(): Promise<SystemSetting[]> {
  const res = await api.get<SystemSetting[]>('/settings');
  return res.data;
}

export async function updateSetting(key: string, value: string): Promise<SystemSetting> {
  const res = await api.put<SystemSetting>(`/settings/${encodeURIComponent(key)}`, { value });
  return res.data;
}

export async function listSettingHistory(key: string): Promise<SystemSettingHistoryEntry[]> {
  const res = await api.get<SystemSettingHistoryEntry[]>(
    `/settings/${encodeURIComponent(key)}/history`,
  );
  return res.data;
}

/** 의뢰서 7-3 — 키 라벨/설명 (시드와 별도로 화면 한국어 라벨) */
export const SETTING_LABELS: Record<string, { label: string; description: string }> = {
  'alert.unused_days': {
    label: '미사용 경보 임계값 — 브레인가드테라피',
    description: '연속 미사용 일수가 이 값 이상이면 미사용 경보를 자동 생성합니다',
  },
  'alert.voice_unused_days': {
    label: '미사용 경보 임계값 — 보이스웰니스',
    description:
      '연속 미사용 일수가 이 값 이상이면 미사용 경보를 자동 생성합니다. 계정이 연결된 입소자만 대상입니다',
  },
  'recommendation.threshold_red': {
    label: '추천 등급 — 빨강 임계값',
    description: '평균 점수가 이 값 이하면 빨강 등급으로 표시합니다',
  },
  'recommendation.threshold_yellow': {
    label: '추천 등급 — 노랑 임계값',
    description: '평균 점수가 이 값 이하면 노랑 등급으로 표시합니다',
  },
  'facility.avg_comparison_enabled': {
    label: '시설 평균 비교 표시',
    description: '입소자 점수를 시설 전체 평균과 비교해 표시합니다',
  },
  'outpatient.validity_days_a': {
    label: '외래 A 유효 기간 (일)',
    description: '외래 A 등록 유효 일수',
  },
  'outpatient.validity_days_b': {
    label: '외래 B 유효 기간 (일)',
    description: '외래 B 등록 유효 일수',
  },
};
